import React from 'react';

export default function Loading() {
  return (
    <>
      {Array.from({ length: 12 }, (_, index) => (
        <div key={index} className="result-line animate-pulse">
          <div>
            <div className="result-meta">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" />
              </ul>
              <div className="result-line__uri" />
            </div>
            <div className="result-line__title" />
            <p className="result-line__description" />
          </div>
        </div>
      ))}
    </>
  );
}
